import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=bd3c195e&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=bd3c195e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3c195e",
  null
  
)

export default component.exports